import { Outlet } from 'react-router-dom'

const CarInformation = () => <Outlet />

export default CarInformation
